module.exports = __webpack_public_path__ + "img/swiper-banner14401.53982ff4.webp";